import Core from "@/modules/core/service/Core";
import CSiteIcon from "@/modules/msd/unit/components/controlls/CSiteIcon.vue";
import CListCard from "@/modules/core/components/utils/CListCard.vue";


export default  {
    components: {
        CSiteIcon,
        CListCard
    },

    props: {
        item: {

        }
    },

    methods: {
        format (value) {
            return Core.format.datetime.display(value)
        },

        dateAsString (value) {
            return Core.format.date.display(value)
        },
    },
}
